import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { t } from '@/plugins/i18n'
import { isMultiStore } from '@/store'
import { nextTick, onBeforeMount, onMounted, ref, computed } from 'vue'
import { ElSelect, ElOption, ElFormItem, ElForm } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Object,
    default: () => ({
      cn: [],
      kr: []
    })
  },
  item: {
    type: Object,
    default: () =>
      ({ intShipConfigId: null })
  }

},
  emits: ['changeIntShip', 'changeIntShipBach'],
  setup(__props, { emit: emits }) {

const props = __props


// const expressList: any = ref()
const intShipConfigId: any = ref()
const intShipConfigIdCn: any = ref()
const intShipConfigIdKr: any = ref()
const isbatch: any = ref(false)

onBeforeMount(() => {
  isbatch.value = !!props.item[0]
  intShipConfigId.value = props.item.intShipConfigId ? props.item.intShipConfigId : ''
  // nextTick(() => {
  //   // console.log(props.item[0])
  //   const tmpcode = props.item[0]?.receiver?.countryCode || props.item.receiver?.countryCode
  //   const tmpintShipConfigId = !isbatch.value ? props.item?.intShipConfigId : 0
  //   const tmplist = props.list
  //   // console.log('items', tmpcode)
  //   // console.log('tmplist', tmplist, tmpintShipConfigId)
  //   const filteredData = computed(() => {
  //     // return tmplist.filter((item: any) => (item as any).countryCode.includes(tmpcode))
  //     return tmplist.filter((item: any) => {
  //       return (
  //         (item as any).countryCode.includes(tmpcode) ||
  //         (item as any).intShipConfigId.includes(tmpintShipConfigId as any)
  //       )
  //     })
  //   })
  //   expressList.value = filteredData.value
  // })
})

const expressList:any = computed(() => {
  const tmpcode = props.item[0]?.receiver?.countryCode || props.item.receiver?.countryCode
  const tmpintShipConfigId = !isbatch.value ? props.item?.intShipConfigId : 0
  const tmplist = props.list
  const filteredData = computed(() => {
    return tmplist.filter((item: any) => {
      return (
        (item as any).countryCode.includes(tmpcode) ||
        (item as any).intShipConfigId.includes(tmpintShipConfigId as any)
      )
    })
  })
  return filteredData.value
})

const changeSelect = (val: string) => {
  // const isbatch = !!props.item[0]
  // console.log('props.item.shopOrderId', props.item.shopOrderId)
  const tmpcountryCode = props.item[0]?.receiver?.countryCode || props.item.receiver?.countryCode

  if (isbatch.value) {
    const shopOrderIds = props.item.map((d: { shopOrderId: any }) => d.shopOrderId)
    emits('changeIntShipBach', {
      cn: intShipConfigIdCn.value,
      kr: intShipConfigIdKr.value
    }, shopOrderIds, tmpcountryCode)
  } else {
    emits('changeIntShip', val, props.item.shopOrderId, tmpcountryCode)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElForm), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ElFormItem), {
        label: isbatch.value ? _unref(isMultiStore)() ? _unref(t)('中国仓商品物流配置') : _unref(t)('国际物流配置') : '',
        "custom-class": "Expresses-item"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElSelect), {
            modelValue: intShipConfigIdCn.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intShipConfigIdCn).value = $event)),
            filterable: "",
            placeholder: _unref(t)('请选择物流公司'),
            onChange: changeSelect
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.cn, (item) => {
                return (_openBlock(), _createBlock(_unref(ElOption), {
                  key: item.intShipConfigId,
                  label: item.distribution,
                  value: item.intShipConfigId
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_unref(isMultiStore)())
        ? (_openBlock(), _createBlock(_unref(ElFormItem), {
            key: 0,
            label: isbatch.value ? _unref(t)('韩国仓商品物流配置') : '',
            "custom-class": "Expresses-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelect), {
                modelValue: intShipConfigIdKr.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((intShipConfigIdKr).value = $event)),
                filterable: "",
                placeholder: _unref(t)('请选择物流公司'),
                onChange: changeSelect
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list.kr, (item) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: item.intShipConfigId,
                      label: item.distribution,
                      value: item.intShipConfigId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})